import { useRef, useState, useEffect, useCallback } from 'react';
import { nanoid } from 'nanoid';
import { AppInteractionType, PermissionContext, } from '@tribeplatform/gql-client/types';
import { SelectItemsQueryTypes } from './types.js';
export const useSelectItems = ({ callbackId, items: uncleanItems, appId, getValues, useInteractions, interactionEmitter, }) => {
    const interactionId = useRef(nanoid());
    const isFetching = useRef(false);
    const [items, setItems] = useState([]);
    const { loadInteractions } = useInteractions({});
    const fetchMore = useCallback(async ({ type, text }) => {
        try {
            if (!appId || !callbackId) {
                return;
            }
            isFetching.current = true;
            if (type === SelectItemsQueryTypes.Search) {
                await loadInteractions({
                    appId,
                    interactionId: interactionId.current,
                    context: PermissionContext.NETWORK,
                    callbackId,
                    dynamicBlockKey: 'settings',
                    inputs: {
                        type: 'search',
                        query: text,
                        formValues: typeof getValues === 'function' ? getValues() : {},
                    },
                });
            }
        }
        catch (error) {
            throw new Error(error);
        }
    }, [loadInteractions, callbackId, appId, getValues]);
    const getUncleanItems = useCallback(() => {
        try {
            return typeof uncleanItems === 'string'
                ? JSON.parse(uncleanItems)
                : uncleanItems;
        }
        catch (err) {
            return [];
        }
    }, [uncleanItems]);
    useEffect(() => {
        const cleanedItems = getUncleanItems();
        if (cleanedItems.length) {
            setItems(cleanedItems);
        }
    }, [getUncleanItems]);
    useEffect(() => {
        const dataListenerHandler = (args) => {
            if (args.interactionId === interactionId.current) {
                isFetching.current = false;
                const newItems = args.props.items;
                if (!newItems.length) {
                    return;
                }
                setItems(newItems);
            }
        };
        if (interactionEmitter) {
            interactionEmitter.on(AppInteractionType.Data, dataListenerHandler);
        }
        return () => {
            if (interactionEmitter) {
                if (interactionId) {
                    interactionEmitter.removeListener(AppInteractionType.Data, dataListenerHandler);
                }
            }
        };
    }, [interactionEmitter]);
    return { fetchMore, items, isFetching: isFetching.current };
};
//# sourceMappingURL=useSelectItems.js.map